import React, { useState, useEffect, useRef } from "react";
import "./Messages.scss";
import Header from "Components/Header/Header";
import Footer from "Components/Footer/Footer";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useFetchGet } from "Services/api";
import { updateMessages } from "Redux/Actions/messagesActions";
import Modal from "Components/Modal/Modal";
import Conversations from "Components/Messages/Conversations/Conversations";
import MessagesContainer from "Components/Messages/MessagesContainer/MessagesContainer";
import axios from "axios";
import { InputTextarea } from "primereact/inputtextarea";
import SearchPeople from "Components/SearchPeople/SearchPeople";
import { Toast } from "primereact/toast";

const Messages = (props) => {
  const conversationData = useFetchGet(
    `/conversations/user/${props.auth.userConnected.id}`,
    props.auth.token
  );
  const messageStatusesData = useFetchGet(
    "/message_statuses",
    props.auth.token
  );
  const [modalNewConversation, setModalNewConversation] = useState(false);
  const [receiver, setReceiver] = useState(null);
  const [firstMessage, setFirstMessage] = useState("");
  const cancelToast = useRef(null);

  // useEffect de chargement
  useEffect(() => {
    if (conversationData.loaded) {
      if (conversationData.data.length > 0) {
        orderConversations(conversationData.data);
      } else {
        props.handleMessages({
          myConversations: [],
          currentConversation: null,
        });
      }
    }

    if (messageStatusesData.loaded && messageStatusesData.data.length === 2) {
      props.handleMessages({
        newId: messageStatusesData.data.find(
          (messageStatus) => messageStatus.label === "NEW"
        )?.id,
        openId: messageStatusesData.data.find(
          (messageStatus) => messageStatus.label === "OPEN"
        )?.id,
      });
    }
  }, [conversationData.loaded, messageStatusesData.loaded]);

  // Ordonne tous les messages dans les conv par ordre de date de création
  // Ordonne les conversations par ordre du dernier message
  const orderConversations = (conversationData) => {
    const convWithoutMessages = conversationData.filter(
      (conv) => conv.messages.length === 0
    );
    const tempMyConv = conversationData
      // filtre les conv cachées
      .filter(
        (conversation) =>
          !conversation.hiddenBy ||
          conversation.hiddenBy.id !== props.auth.userConnected.id
      )
      .filter((conversation) => conversation.messages.length > 0)
      //Ordonne les messages dans les conv
      .map((conversation) => {
        conversation.messages = conversation.messages.sort((a, b) => {
          return new Date(b.createdAt) - new Date(a.createdAt);
        });
        return conversation;
      })
      // Ordonne les conv par date
      .sort((a, b) => {
        return (
          new Date(b.messages[0]?.createdAt) -
          new Date(a.messages[0]?.createdAt)
        );
      });
    props.handleMessages({
      myConversations: [...tempMyConv, ...convWithoutMessages],
      currentConversation: tempMyConv[0],
    });
  };

  // Fonction de création d'une conv
  const createConversation = () => {
    const data = {
      users: [
        `api/users/${props.auth.userConnected.id}`,
        `api/users/${receiver.id}`,
      ],
    };
    axios
      .post(`${process.env.REACT_APP_BASE_URL_API}/conversations`, data, {
        accept: "application/json",
        Authorization: `Bearer ${props.auth.token}`,
      })
      .then((res) => {
        sendFirstMessage(res.data);
      })
      .catch((error) => {
        props.auth.toast?.current?.show({
          severity: "error",
          summary: "Erreur",
          detail: error?.response?.data?.detail || "Une erreur est survenue",
          life: 5000,
        });
      });
  };

  // Fonction de création de message suite à la création d'une conv
  const sendFirstMessage = (conversation) => {
    // Format le body pour la requete
    const data = {
      content: firstMessage,
      conversation: `api/conversations/${conversation.id}`,
      user: `api/users/${props.auth.userConnected.id}`,
      messageStatus: `api/message_statuses/${props.messages.newId}`,
    };
    axios
      .post(`${process.env.REACT_APP_BASE_URL_API}/messages`, data, {
        headers: props.auth.token
          ? {
              accept: "application/json",
              Authorization: `Bearer ${props.auth.token}`,
            }
          : {
              accept: "application/json",
            },
      })
      .then((res) => {
        // formate la réponse
        const isExisting = conversationData.data.some(
          (conv) => conv.id === conversation.id
        );
        let userTemp = conversation.users.filter(
          (user) => user.id === props.auth.userConnected.id
        )[0];
        userTemp.imageUrl = props.auth.userConnected.imageUrl;
        const formatedResponse = {
          id: res.data.id,
          createdAt: res.data.createdAt,
          content: res.data.content,
          user: userTemp,
          messageStatus: `api/message_statuses/${props.messages.newId}`,
        };
        // Ajoute le nouveau message à la conv
        conversation.messages = conversation.messages.concat(formatedResponse);
        // Si la conv et nouvelle ajoute la conv à la liste de conv
        // Sinon update la conv
        let tempConversations = null;
        !isExisting
          ? (tempConversations = [conversation].concat(
              props.messages.myConversations
            ))
          : (tempConversations = conversationData.data.map((conv) => {
              if (conv.id === conversation.id) {
                // si la conversation était cachée l'affiche de nouveau
                if (conversation.hiddenBy != null) {
                  conversation.hiddenBy = null;
                  showConversation(conversation);
                }
                return conversation;
              } else return conv;
            }));
        setFirstMessage("");
        // Reordonne les conv
        orderConversations(tempConversations);
      })
      .catch((error) => {
        cancelToast.current.show({
          severity: "error",
          summary: "error : ",
          detail:
            error?.response?.data?.detail ||
            "Une erreur est survenue, le message n'a pas pu être envoyé.",
          life: 3000,
        });
      });
  };

  const showConversation = (conversation) => {
    const data = {};
    axios
      .post(
        `${process.env.REACT_APP_BASE_URL_API}/conversations/show/${conversation.id}`,
        data,
        {
          accept: "application/json",
          Authorization: `Bearer ${props.auth.token}`,
        }
      )
      .catch((error) => {
        props.auth.toast?.current?.show({
          severity: "error",
          summary: "Erreur",
          detail: error?.response?.data?.detail || "Une erreur est survenue",
          life: 5000,
        });
      });
  };

  return (
    <div className="messages">
      <Toast ref={cancelToast} />
      <Header />
      <div className="messages_page">
        <div className="messages_page_top">
          <div className="messages_page_top_left">
            <h1 className="h1_trait_dessus">Messagerie personnelle</h1>
          </div>
          <div className="messages_page_top_right">
            <div className="create_message">
              <button
                className="btn-bleu create_message_button"
                onClick={() => {
                  setReceiver(null);
                  setFirstMessage("");
                  setModalNewConversation(true);
                }}
              >
                Nouvelle conversation
              </button>
            </div>
          </div>
        </div>
        {props.messages.currentConversation && (
          <div className="messages_page_bottom">
            <div className="messages_page_left">
              <Conversations></Conversations>
            </div>
            <div className="messages_page_right">
              <MessagesContainer
                orderConversations={(data) => orderConversations(data)}
                cancelToast={cancelToast}
              ></MessagesContainer>
            </div>
          </div>
        )}
      </div>

      {modalNewConversation && (
        <Modal
          visible={modalNewConversation}
          setVisible={setModalNewConversation}
          header={`Nouvelle conversation`}
        >
          <div className="modal_new_conversation">
            <SearchPeople setUser={setReceiver}></SearchPeople>
            <InputTextarea
              className="modal_new_conversation_textarea"
              placeholder="Envoyez un premier message"
              value={firstMessage}
              onChange={(e) => setFirstMessage(e.target.value)}
            />
            <button
              className="btn-bleu modal_new_conversation_button"
              onClick={() => {
                if (firstMessage !== "" && receiver) {
                  setModalNewConversation(false);
                  createConversation();
                }
              }}
            >
              Créer la conversation
            </button>
          </div>
        </Modal>
      )}

      <Footer />
    </div>
  );
};

Messages.propTypes = {
  auth: PropTypes.object,
  messages: PropTypes.object,
  handleMessages: PropTypes.func,
};
const mapStateToProps = (state) => ({
  auth: state.auth,
  messages: state.messages,
});
const mapDispatchToProps = (dispatch) => ({
  handleMessages: (value) => {
    dispatch(updateMessages(value));
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(Messages);
